import { Button, CircularProgress, Input, Option, Select, selectClasses, styled } from '@mui/joy'
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { BASE_URL, BLACK, PRIMARY, WHITE } from '../../appConstants'
import axios from 'axios'
import appError from '../../appError'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import PaginationComponent from '../commonComponents/PaginationComponent'

type VendorProps = {

}

type FilterStateObj = {
    limit: number;
    page: number;
};

type Vendor = {
    id: string;
    originalName: string;
    createdAt: string;
    reportStartTime: string;
    reportEndTime: string;
    status: string;
}

const Vendor: React.FC<VendorProps> = ({ }) => {
    const { brand_id, platform_id } = useParams();

    const [loading, setLoading] = useState<string>("");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filterState, setFilterState] = useState<FilterStateObj>({
        limit: 10,
        page: 1,
    });
    const [brandId, setbrandId] = useState<string>("");
    const [platformId, setplatformId] = useState<string>("");
    const [dataFetchingState, setDataFetchingState] = useState<string>("");
    const [reportsArr, setReportsArr] = useState<Vendor[]>([]);
    const [searchReportName, setSearchReportName] = useState<string>("");
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const VisuallyHiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
    `;

    const onFileChange = async (event: ChangeEvent<HTMLInputElement>, type: string) => {

        if (!(event.target.files && event.target.files.length > 0)) {
            return appError("File not selected.");
        }

        try {
            setLoading(type)
            setUploadProgress(0); // Reset progress
            let file = event.target.files[0];
            const token = localStorage.getItem("token");

            const formData = new FormData();
            formData.append('myFile', file);

            const res = await axios.post(`${BASE_URL}brand/report/fileUpload?brand_id=${brandId}&platform_id=${platformId}&sub_module_for_platform_id=1e5a0cdf-79fd-4a4c-a9c4-9782222f20a1&type=${type}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    }
                }
            });
            const { message, data: { filename, originalname } } = res?.data;
            setUploadProgress(100); 
            fetchVendorData(brandId, platformId, "");
            toast.success(message);
        } catch (err: any) {
            appError(err?.response?.data?.data?.message);
        } finally {
            setLoading("");
            // Reset progress after a short delay to show 100% completion
            setTimeout(() => {
                setUploadProgress(0);
            }, 2000);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const getLocalTime12Hour = (isoString: string) => {
        const date = new Date(isoString);
        return date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      }

    const fetchVendorData = async (ag_brand_id: string, ag_platform_id: string, ag_searchReportName: string = "") => {
        if (!ag_brand_id && !ag_platform_id) {
            return;
        }

        const token = localStorage.getItem("token");
        try {
            setDataFetchingState("LOADING");
            const headers = {
                Authorization: `Bearer ${token}`,
            };
            let api = `${BASE_URL}brand/getReports?brand_id=${ag_brand_id}&platform_id=${ag_platform_id}&sub_module_for_platform_id=1e5a0cdf-79fd-4a4c-a9c4-9782222f20a1&type=VENDOR&report_Name=${ag_searchReportName}&limit=${filterState?.limit}&page=${filterState?.page}`;
            const result = await axios.get(api, { headers });

            const { rows, reports } = result?.data?.data;
            if (rows === 0) {
                setDataFetchingState("EMPTY");
            } else {
                setTotalRows(rows);
                const newReportsArr = reports?.map((report: any) => {
                    return {
                        id: report?.transaction_id,
                        originalName: report?.original_file_name,
                        createdAt: report?.created_at,
                        reportStartTime: report?.report_start_timestamp,
                        reportEndTime: report?.report_complete_timestamp,
                        status: report?.status
                    }
                });
                setReportsArr(newReportsArr);
                setDataFetchingState("SUCCESS");
            }
        } catch (error) {
            appError(error);
        }
    };

    useEffect(() => {
        if (brand_id && platform_id) {
            fetchVendorData(brand_id, platform_id, "");
            setbrandId(brand_id);
            setplatformId(platform_id);
        }
    }, [brand_id, platform_id, filterState]);

    const onSearchReportNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchReportName(value);
        if(value.trim() === "") {
            fetchVendorData(brandId, platformId, "");
        }
    }

    const handleSearchClick = (ag_brand_id: string, ag_platform_id: string) => {
        fetchVendorData(ag_brand_id, ag_platform_id, searchReportName);
    }

    return (
        <div className='h-full px-10 py-6 flex flex-col gap-6'>
            <div className="flex justify-between">
                <div className="flex" >
                    <Input
                        value={searchReportName}
                        onChange={(e) => onSearchReportNameChange(e)}
                        startDecorator={
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M17.9422 17.0578L14.0305 13.1469C15.1642 11.7857 15.7296 10.0398 15.6089 8.27244C15.4883 6.50506 14.6909 4.85223 13.3826 3.65779C12.0744 2.46334 10.356 1.81926 8.58493 1.85951C6.81388 1.89976 5.12653 2.62125 3.87389 3.87389C2.62125 5.12653 1.89976 6.81388 1.85951 8.58492C1.81926 10.356 2.46335 12.0744 3.65779 13.3826C4.85223 14.6909 6.50506 15.4883 8.27245 15.6089C10.0398 15.7296 11.7857 15.1642 13.1469 14.0305L17.0578 17.9422C17.1159 18.0003 17.1848 18.0463 17.2607 18.0777C17.3366 18.1092 17.4179 18.1253 17.5 18.1253C17.5821 18.1253 17.6634 18.1092 17.7393 18.0777C17.8152 18.0463 17.8841 18.0003 17.9422 17.9422C18.0003 17.8841 18.0463 17.8152 18.0777 17.7393C18.1092 17.6634 18.1253 17.5821 18.1253 17.5C18.1253 17.4179 18.1092 17.3366 18.0777 17.2607C18.0463 17.1848 18.0003 17.1159 17.9422 17.0578ZM3.125 8.75C3.125 7.63748 3.4549 6.54994 4.07298 5.62491C4.69107 4.69989 5.56957 3.97892 6.5974 3.55317C7.62524 3.12743 8.75624 3.01604 9.84738 3.23308C10.9385 3.45012 11.9408 3.98585 12.7275 4.77252C13.5141 5.55919 14.0499 6.56147 14.2669 7.65261C14.484 8.74376 14.3726 9.87475 13.9468 10.9026C13.5211 11.9304 12.8001 12.8089 11.8751 13.427C10.9501 14.0451 9.86252 14.375 8.75 14.375C7.25866 14.3733 5.82888 13.7802 4.77435 12.7256C3.71982 11.6711 3.12665 10.2413 3.125 8.75Z" fill="#1C1C1C" fill-opacity="0.4" />
                            </svg>
                        }
                        sx={{
                            "--Input-focusedThickness": "0px",
                            ':focus-within': {
                                border: `1px solid ${PRIMARY.P_BLue}`,
                            },
                            boxShadow: 'none',
                            height: 40,
                            width: 320,
                            borderRadius: 8,

                        }}
                        placeholder="Search"
                    />
                   
                    <Button
                        onClick={() => handleSearchClick(brandId, platformId)}
                        sx={{
                            height: 40,
                            width: 120,
                            fontSize: 14,
                            fontWeight: 500,
                            backgroundColor: PRIMARY.P_BLue,
                            lineHeight: "20px",
                            marginLeft: "12px",
                            borderRadius: 8
                        }}
                    >Search</Button>
                </div>

                 <div className='flex gap-2 items-center'>
                     {loading === "VENDOR" && uploadProgress > 0 && (
                         <div style={{
                             fontSize: 14,
                             fontWeight: 400,
                             lineHeight: "20px",
                             color: BLACK.B_80,
                         }}>{uploadProgress}%</div>
                     )}
                    <Button
                        loading={loading === "VENDOR"}
                        onClick={handleButtonClick}
                        sx={{
                            height: 40,
                            fontSize: 14,
                            fontWeight: 500,
                            backgroundColor: PRIMARY.P_BLue,
                            lineHeight: "20px",
                            borderRadius: 8
                        }}>
                        <div>Upload Reports File Here </div>
                        <VisuallyHiddenInput
                            ref={fileInputRef}
                            onChange={(e: any) => onFileChange(e, "VENDOR")}
                            type="file" />
                    </Button>
                </div>
            </div>

            <div
                style={{
                    height: "calc(100vh - 236px)",
                    borderRadius: 12,
                    boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.05",
                    backgroundColor: "#FFF",
                }}
            >
                <div
                    className="flex items-center w-full"
                    style={{
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        height: 56,
                        fontSize: 14,
                        fontWeight: 700,
                        lineHeight: "20px",
                        backgroundColor: PRIMARY.P_Purple50,
                    }}
                >
                    <div className="p-4" style={{ width: "40%" }}>
                        Report Name
                    </div>
                    <div className="p-4" style={{ width: "15%" }}>
                        Created At
                    </div>
                    <div className="p-4" style={{ width: "15%" }}>
                        Report Start Time
                    </div>
                    <div className="p-4" style={{ width: "15%" }}>
                        Report End Time
                    </div>
                    <div className="p-4 text-end" style={{ width: "15%" }}>
                        Status
                    </div>
                </div>

                {dataFetchingState === "LOADING" && (
                    <div
                        className="flex justify-center items-center"
                        style={{
                            position: "absolute",
                            backgroundColor: "#FFF",
                            height: "calc(100vh - 352px)",
                            width: "calc(100% - 80px)",
                        }}
                    >
                        <CircularProgress />
                    </div>
                )}

                {dataFetchingState === "EMPTY" && (
                    <div
                        className="flex justify-center items-center"
                        style={{
                            position: "absolute",
                            height: "calc(100vh - 352px)",
                            width: "calc(100% - 80px)",
                        }}
                    >
                        <div
                            style={{
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                color: BLACK.B_40,
                            }}
                        >
                            No data found
                        </div>
                    </div>
                )}

                <div
                    style={{ height: "calc(100vh - 352px)" }}
                    className="overflow-y-auto"
                >
                    {reportsArr?.length > 0 &&
                        reportsArr?.map((report: Vendor) => {
                            return (
                                <div
                                    className="flex items-center w-full"
                                    key={report?.id}
                                    style={{
                                        height: 52,
                                        borderBottom: `1px solid ${BLACK.B_5}`,
                                        color: BLACK.B_80,
                                    }}
                                >
                                    <div
                                        className="p-4 flex items-center gap-2 self-stretch"
                                        style={{ width: "40%" }}
                                    >
                                        <div
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                lineHeight: "18px",
                                                color: BLACK.B_80,
                                              }}
                                        >
                                            {report?.originalName}
                                        </div>
                                    </div>

                                    <div
                                        className="flex p-4 items-center gap-2 self-stretch"
                                        style={{ width: "15%" }}
                                    >
                                        <div
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                lineHeight: "18px",
                                            }}
                                        >
                                            {report?.createdAt ? report?.createdAt.split("T")[0].split("-").reverse().join("-") + " " + getLocalTime12Hour(report?.createdAt) : "-"}
                                        </div>
                                    </div>

                                    <div
                                        className="flex p-4 items-center gap-2 self-stretch"
                                        style={{ width: "15%" }}
                                    >
                                        <div
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                lineHeight: "18px",
                                            }}
                                        >
                                            {report?.reportStartTime ? report?.reportStartTime.split("T")[0].split("-").reverse().join("-") + " " + getLocalTime12Hour(report?.reportStartTime) : "-"}
                                        </div>
                                    </div>

                                    <div
                                        className="flex p-4 items-center gap-2 self-stretch"
                                        style={{ width: "15%" }}
                                    >
                                        <div
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                lineHeight: "18px",
                                            }}
                                        >
                                            {report?.reportEndTime ? report?.reportEndTime.split("T")[0].split("-").reverse().join("-") + " " + getLocalTime12Hour(report?.reportEndTime) : "-"}
                                        </div>
                                    </div>

                                    <div
                                        className="flex p-4 justify-end gap-2 self-stretch"
                                        style={{ width: "15%", textAlign: "end" }}
                                    >
                                        <div
                                            style={{
                                                color: report?.status === "queue" ? "#855F00" : report?.status === "success" ? "#186846" : "#DB0000",
                                                fontSize: 12,
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                lineHeight: "18px",
                                                textAlign: "end",
                                            }}
                                        >
                                            {report?.status}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>

                <div
                    className="flex justify-between items-center px-4"
                    style={{
                        borderTop: `1px solid ${BLACK.B_5}`,
                        height: 60,
                        borderBottomLeftRadius: 12,
                        borderBottomRightRadius: 12,
                    }}
                >
                    <div className="flex items-center">
                        <div
                            className="mr-2"
                            style={{ fontSize: 12, fontWeight: 400, lineHeight: "18px" }}
                        >
                            Rows per page:
                        </div>
                        <Select
                            //  onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "status")}
                            onChange={(e, limit) =>
                                setFilterState((prevState) => ({
                                    ...prevState,
                                    page: 1,
                                    limit: limit ? limit : 0 * 1,
                                }))
                            }
                            // placeholder="Select State"
                            name="status"
                            value={filterState.limit}
                            indicator={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M9.56251 12.0625L6.54167 9.04171C6.50001 9.00004 6.46876 8.9549 6.44792 8.90629C6.42709 8.85768 6.41667 8.8056 6.41667 8.75004C6.41667 8.63893 6.45487 8.54171 6.53126 8.45837C6.60764 8.37504 6.70834 8.33337 6.83334 8.33337H13.1667C13.2917 8.33337 13.3924 8.37504 13.4688 8.45837C13.5451 8.54171 13.5833 8.63893 13.5833 8.75004C13.5833 8.77782 13.5417 8.87504 13.4583 9.04171L10.4375 12.0625C10.3681 12.132 10.2986 12.1806 10.2292 12.2084C10.1597 12.2362 10.0833 12.25 10 12.25C9.91667 12.25 9.84028 12.2362 9.77084 12.2084C9.70139 12.1806 9.63195 12.132 9.56251 12.0625Z"
                                        fill="#1C1C1C"
                                        fill-opacity="0.8"
                                    />
                                </svg>
                            }
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "80px",
                                height: "28px",
                                backgroundColor: WHITE.W_100,
                                color: BLACK.B_80,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                border: `1px solid ${BLACK.B_10}`,
                                [`& .${selectClasses.indicator}`]: {
                                    transition: "0.2s",
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: "rotate(-180deg)",
                                    },
                                },
                            }}
                        >
                            <Option value={10}>10</Option>
                            <Option value={20}>20</Option>
                            <Option value={50}>50</Option>
                        </Select>
                    </div>
                    {/* ---------------------Pagination Component------------------ */}
                    <PaginationComponent
                        page={filterState.page}
                        limit={filterState.limit}
                        totalRows={totalRows}
                        onChange={(page) =>
                            setFilterState((prevState) => ({ ...prevState, page }))
                        }
                    />
                    {/* ---------------------Pagination Component------------------ */}
                </div>
            </div>
        </div>
    )
}

export default Vendor